import { useQuery } from '@tanstack/react-query';

import { contractPricingQueryOptions } from '../data-provider';
import type { ContractPricingParams } from '../models';

export const useContractPricing = (params: ContractPricingParams) => useQuery(contractPricingQueryOptions(params));
